type GlobalData = {
  route?: {
    id?: string;
  };
  data?: {
    userInfo?: {
      customerId?: string;
    };
  };
};

declare global {
  interface Window {
    rtbhEvents?: Array<Record<string, string>>;
  }
}

export const rtbhHomePageView = ({
  globalData,
}: {
  globalData?: GlobalData;
}): void => {
  const routeId = globalData?.route?.id;

  if (routeId !== "home") {
    return;
  }

  const customerId = globalData?.data?.userInfo?.customerId;

  window.rtbhEvents = window.rtbhEvents || [];
  window.rtbhEvents.push(
    {
      eventType: "home",
    },
    {
      eventType: "uid",
      id: customerId ?? "unknown",
    }
  );
};
